/**
 * Copyright (c) 2018 itemis AG - All rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Contributors:
 * 	andreas muelder - itemis AG
 *
 */
import { shapes, util } from "@clientio/rappid";
import { MARKER } from "./base/validation";
import { BaseNode, BaseView } from "./base/base-node";
import { ElementController } from "./base/element-controller";
import { PreferenceStore } from "../services/preference-store";

export class Choice extends BaseNode {
  defaults() {
    return {
      ...super.defaults,
      type: "Choice",
      fixedRatio: true,
      embedable: false,
      linkable: true,
      size: {
        width: 15,
        height: 15,
      },
      attrs: {
        root: {
          magnetSelector: "body",
        },
        marker: {
          text: MARKER,
          fontFamily: "FontAwesome",
          fontSize: 13,
          x: -5,
          y: 0,
          opacity: 0,
        },
        body: {
          refWidth: "71%",
          refHeight: "71%",
          refX: "50%",
          refY: "0%",
          strokeWidth: 0,
          transform: "rotate(45)",
        },
        inner: {
          refWidth: "57%",
          refHeight: "57%",
          refX: "50%",
          refY: "10%",
          transform: "rotate(45)",
        },
      },
    };
  }

  getFillColor(): string {
    return this.attr(["inner", "fill"]);
  }

  setFillColor(color: string | null) {
    this.attr(["inner", "fill"], color);
    if (color === null) {
      this.removeAttr(["inner", "fill"]);
    }
  }

  getBorderColor(): string {
    return this.attr(["body", "fill"]);
  }

  setBorderColor(color: string | null) {
    this.attr(["body", "fill"], color);
    if (color === null) {
      this.removeAttr(["body", "fill"]);
    }
  }

  getBorderWidth(): number {
    const innerWidth = parseFloat(String(this.attr(["inner", "refWidth"]))) || 57;
    return Math.round((71 - innerWidth) / 2.8);
  }

  setBorderWidth(width: number) {
    const totalGap = width * 2.8;
    const innerSize = Math.max(1, 71 - totalGap);
    const innerRefY = totalGap * 0.714;
    this.attr(["inner", "refWidth"], innerSize + "%");
    this.attr(["inner", "refHeight"], innerSize + "%");
    this.attr(["inner", "refY"], innerRefY + "%");
  }

  resetDefaults() {
    this.setFillColor(null);
    this.setBorderColor(null);
    this.attr(["inner", "refWidth"], "57%");
    this.attr(["inner", "refHeight"], "57%");
    this.attr(["inner", "refY"], "10%");
  }

  markup = [
    {
      tagName: "rect",
      selector: "body",
    },
    {
      tagName: "rect",
      selector: "inner",
    },
    {
      tagName: "text",
      selector: "marker",
    },
  ];
}

export class ChoiceView extends BaseView {}

export class ChoiceController extends ElementController {}

util.assign(shapes, {
  Choice,
  ChoiceView,
  ChoiceController,
});
